// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"208":"567d5e5d","299":"ad5f395d","460":"df7eaa7a","473":"32926c53","569":"68240404","581":"9dcbc89c","725":"150bbf9f","866":"ca6f6ebe"}[chunkId] + ".chunk.js";
};